import { IntlShape } from 'react-intl';
import { EventAttributeTypesValues, IEventAttributesTypes } from '../api/attributes.dao';
export const eventAttributeTypes = (intl: IntlShape): IEventAttributesTypes[] => [
    {
        value: EventAttributeTypesValues.SINGLE_SELECT_DROPDOWN,
        label: intl.formatMessage({
            id: `oe.inputType.SINGLE_SELECT_DROPDOWN`,
            description: 'Label text',
            defaultMessage: 'Single-select Dropdown',
        })
    },
    {
        value: EventAttributeTypesValues.CHECKBOX,
        label: intl.formatMessage({
            id: `oe.inputType.CHECKBOX`,
            description: 'Label text',
            defaultMessage: 'Checkbox',
        })
    },
    {
        value: EventAttributeTypesValues.MULTI_SELECT_DROPDOWN,
        label: intl.formatMessage({
            id: `oe.inputType.MULTI_SELECT_DROPDOWN`,
            description: 'Label text',
            defaultMessage: 'Multi-select Dropdown',
        })
    },
    {
        value: EventAttributeTypesValues.FREE_TEXT,
        label: intl.formatMessage({
            id: `oe.inputType.FREE_TEXT`,
            description: 'Label text',
            defaultMessage: 'Free Text',
        })
    },
    {
        value: EventAttributeTypesValues.PARAGRAPH,
        label: intl.formatMessage({
            id: `oe.inputType.PARAGRAPH`,
            description: 'Label text',
            defaultMessage: 'Paragraph',
        })
    },
];